import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { RETRIEVE_POPUP, ISTATACARD, base_https_url } from 'src/app/config/app-settings.config';
import { IwService } from 'src/app/services/iw.service';
import { ThemeService } from 'src/app/services/theme.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { WSCallDetailsData } from "src/app/model/creat-update-lead";
declare var analytics: any;
@Component({
  selector: 'app-retrieve-pop-up',
  templateUrl: './retrieve-pop-up.component.html',
  styleUrls: ['./retrieve-pop-up.component.scss']
})
export class RetrievePopUpComponent implements OnInit {
  @Input() cardDcrData: any;
  wsDetails = new WSCallDetailsData();
  firstName: string;
  mobileNumber: string;
  fromRetrieve: boolean;
  retrieve_popup: any;
  eapplyFormLabel: any;
  poupImg: any;
  TATACARD = ISTATACARD;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RetrievePopUpComponent>,
    private sharedData: SharedServiceService,
    private iwService: IwService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.retrieve_popup = RETRIEVE_POPUP;
    this.eapplyFormLabel = this.iwService.geteapplyFormLabelDcr().dcrContent.root;
    this.poupImg = this.TATACARD ? '/tata-card-en/resources/img/eapply/existing-app.png' : '/sbi-card-en/resources/img/eapply/existing-app.png';
    const xml = this.cardDcrData;
  }

  close() {
    this.dialogRef.close(false);
    /* Analytics added */
    if(window['analytics']){
       console.log('Shared Data', this.sharedData.sbic_card_Type);
      analytics.track('eapply__click__continue_with_new_application', {
        'MODE_OF_CONVERSION': '',
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
        'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
        'CHANNEL_NAME': this.sharedData.paramschannel,
        'JOURNEY_NAME': 'EAPPLY',
        'COMPANY_NAME': this.wsDetails.WSCallUserCompany,
        'DOB': this.wsDetails.WSCallUserDOB,
        'DESIGNATION': this.wsDetails.WSCallUserDesignation,
        'ANNUAL_SALARY': this.wsDetails.WSCallUserAnnualIncomeValue,
        'OFFICE_PINCODE': this.wsDetails.WSCallUserOfficePincode,
        'PAN': this.wsDetails.WSCallUserPanNumber,
        'OCCUPATION_TYPE': this.wsDetails.WSCallUserOccupationCode,
        'CARD_TYPE': this.sharedData.sbic_card_Type
        });
    }
  
  }

  retrieveApplication() {
    this.dialogRef.close(true);
    /* Analytics added */
    if(window['analytics']){
       analytics.track('eapply__click__retrieve_existing_application', {
      'MODE_OF_CONVERSION': '',
      'IS_ORGANIC': 'N',
      'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
      'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
      'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
      'CHANNEL_NAME': this.sharedData.paramschannel,
      'JOURNEY_NAME': 'EAPPLY',
      'FIRST_NAME': this.wsDetails.WSCallUserFirstName,
      'LAST_NAME': this.wsDetails.WSCallUserLastName,
      'MIDDLE_NAME': this.wsDetails.WSCallUserMiddleName,
      'EMAIL': this.wsDetails.WSCallUserEmailId,
      'Mobile_no': this.wsDetails.WSCallUserMobileNumber,
      'CITY': this.wsDetails.WSCallUserCity,
      'CARD_TYPE': this.sharedData.sbic_card_Type
      });
     }
  }
}
